import { Drawer, IconButton, Typography } from '@material-tailwind/react'
import { useNavigate } from 'react-router-dom';
import { IoChevronForward, IoClose } from 'react-icons/io5';
import moment from 'moment';
import { useNotificationSocket } from '../../../context/NotificationSocketProvider';



const RightDrawer = ({ openRight, closeDrawerRight }) => {
  const navigate = useNavigate();
  const { socket, notification } = useNotificationSocket();


  const goToMessage = (url, id) => {
    navigate(url);
    removeNotification(id)
    closeDrawerRight();
  }



  const removeNotification = (dd) => {
    if (socket) {
      socket.emit('markAsRead', { id: dd });
    }
  }



  return (
    <Drawer
      placement="right"
      open={openRight}
      onClose={closeDrawerRight}
      className="p-2 z-[999px] h-screen bg-whiter"
    >
      <div className="pb-1 mb-1 border-b border-secondary-300 flex items-center justify-between">
        <Typography variant="h5" color="blue" className='font-montserrat'>
          Notifications
        </Typography>
        <IconButton
          variant="text"
          color="blue"
          onClick={closeDrawerRight}
        >
          <IoChevronForward size={20} color='blue-gray' />
        </IconButton>
      </div>
      <div className='w-full h-[91vh] overflow-y-auto flex flex-col gap-y-1'>
        {
          notification?.length > 0
            ? notification?.map((msgDetails, index) => {
              return (
                <div
                  key={index}
                  className="w-full relative flex flex-col bg-white hover:bg-secondary-100 py-1 px-2 rounded cursor-pointer">
                  <span
                    onClick={() => goToMessage(msgDetails?.redirect?.url, msgDetails?._id)}
                    className='w-full h-full flex flex-col justify-between items-start'>
                    <span className='text-sm font-semibold text-black-2'>
                      {msgDetails?.title}
                    </span>
                    <span className='text-sm font-semibold text-secondary-800'>
                      {msgDetails?.message}
                    </span>
                  </span>
                  <span className='text-xs text-secondary-600'>
                    {moment(msgDetails?.createdAt).fromNow()?.includes("days") ? moment(msgDetails?.createdAt).format("hh:mm a Do MMM, YYYY") : moment(msgDetails?.createdAt).fromNow()}
                  </span>

                  <span
                    onClick={() => removeNotification(msgDetails?._id)}
                    className='absolute top-0 right-0 h-full duration-700 bg-secondary-300 hover:bg-red-300 group px-1 flex flex-col justify-center items-center'>
                    <IoClose size={20} className='text-red-900 group-hover:text-white' />
                  </span>
                </div>
              )
            })
            //   return (
            //     <div
            //       key={index}
            //       className="py-2 px-4 border-b border-secondary-300 flex items-center justify-between"
            //     >
            //       <div className='flex items-center gap-2'>
            //         <img
            //           src={msgDetails?.sender?.profileImage}
            //           alt="user"
            //           className="w-10 h-10 rounded-full"
            //         />
            //         <div className='flex flex-col'>
            //           <Typography variant="h6" color="blue" className='font-montserrat'>
            //             {msgDetails?.sender?.firstName} {msgDetails?.sender?.lastName}
            //           </Typography>
            //           <Typography variant="small" color="gray" className='font-montserrat'>
            //             {msgDetails?.message}
            //           </Typography>
            //         </div>
            //       </div>
            //     </div>
            //   )
            // })
            : <div className='w-full py-2 px-4 text-center text-secondary-600 font-bold text-md'>
              No new Notification
            </div>
        }
      </div>

    </Drawer>
  )
}

export default RightDrawer





// import { Drawer, IconButton, Typography } from '@material-tailwind/react'
// import { useChatSocket, useMessageNotification } from '../../../context/ChatSocketProvider'
// import { useNavigate } from 'react-router-dom';
// import { APP_URLS } from '../../../config';
// import { useSelector } from 'react-redux';
// import { conversationUsersListSelector } from '../../../rdxsga/redux/slices/adminListSlice';
// import { IoChevronForward, IoClose, IoCut } from 'react-icons/io5';
// import moment from 'moment';



// const RightDrawer = ({ openRight, closeDrawerRight }) => {
//   const newMessage = useMessageNotification();
//   const navigate = useNavigate();
//   const userList = useSelector(conversationUsersListSelector);
//   const socket = useChatSocket();


//   const getUserName = id => {
//     let user = userList?.find(d => d?._id === id);

//     return user ? `${user?.user?.firstName} ${user?.user?.middleName} ${user?.user?.lastName}` : ""
//     // //console.log({ user, newMessage })
//   }

//   const goToMessage = (user) => {
//     navigate(APP_URLS.CONVERSATION.ROUTE.concat(`?nn=${user}`))
//     closeDrawerRight();
//   }



//   const removeNotification = (msgDetails) => {
//     if (socket) {
//       socket.emit('removeNotification', msgDetails);
//     }
//   }



//   return (
//     <Drawer
//       placement="right"
//       open={openRight}
//       onClose={closeDrawerRight}
//       className="p-2 z-[999px] h-screen bg-whiter"
//     >
//       <div className="pb-1 mb-1 border-b border-secondary-300 flex items-center justify-between">
//         <Typography variant="h5" color="blue" className='font-montserrat'>
//           Notifications
//         </Typography>
//         <IconButton
//           variant="text"
//           color="blue"
//           onClick={closeDrawerRight}
//         >
//           <IoChevronForward size={20} color='blue-gray' />
//         </IconButton>
//       </div>
//       {
//         (Object.keys(newMessage).length > 0 &&
//           Object.values(newMessage).filter(d => d?.count > d?.notified).length > 0) ? 
// <div className='w-full h-[91vh] overflow-y-auto flex flex-col gap-y-1'>

//           {
//             Object.keys(newMessage).map(d => {

//               return newMessage[d]?.count > newMessage[d]?.notified ? (
//                 <div
//                   className="w-full relative flex flex-col bg-white hover:bg-secondary-100 py-1 px-2 rounded cursor-pointer">
//                   <span
//                     onClick={() => goToMessage(d)}
//                     className='w-full h-full flex flex-col justify-between items-start'>
//                     <span className='text-sm font-semibold text-black-2'>
//                       {getUserName(d)}
//                     </span>
//                     <span className='text-sm font-semibold text-secondary-800'>
//                       {newMessage[d]?.count} new message
//                     </span>
//                   </span>
//                   <span className='text-xs text-secondary-600'>
//                     {moment(newMessage[d].lastMessage).fromNow()?.includes("days") ? moment(newMessage[d].lastMessage).format("hh:mm a Do MMM, YYYY") : moment(newMessage[d].lastMessage).fromNow()}
//                   </span>

//                   <span
//                     onClick={() => removeNotification(newMessage[d])}
//                     className='absolute top-0 right-0 h-full duration-700 bg-secondary-300 hover:bg-red-300 group px-1 flex flex-col justify-center items-center'>
//                     <IoClose size={20} className='text-red-900 group-hover:text-white' />
//                   </span>
//                 </div>
//               ) : <></>
//             })
//           }
//         </div>
//           : <div className='w-full py-2 px-4 text-center text-secondary-600 font-bold text-md'>
//             No new Notification
//           </div>
//       }

//     </Drawer>
//   )
// }

// export default RightDrawer